<template>
  <div class="banner">
    <div class="carousel-container">
      <div class="carousel-wrapper" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
        <div class="carousel-item" v-for="(item, index) in images" :key="index">
          <img :src="item" :alt="'Banner ' + (index + 1)" class="banner-pic">
          <img src="https://cdn.magicmart.vip/website/assets/slogan.png" class="slogan">
        </div>
      </div>
      
      <div class="arrow arrow-left" @click="prevSlide">
       <img src="https://cdn.magicmart.vip/website/assets/arrowLeft.png">
      </div>
      
      <div class="arrow arrow-right" @click="nextSlide">
        <img src="https://cdn.magicmart.vip/website/assets/arrowRight.png">
      </div>
      
      <div class="dots">
        <span 
          v-for="(item, index) in images" 
          :key="index"
          :class="{ 'dot': true, 'active': index === currentIndex }"
          @click="goToSlide(index)"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopBanner',
  data() {
    return {
      currentIndex: 0,
      images: [
        'https://cdn.magicmart.vip/website/assets/banner1.png',
        'https://cdn.magicmart.vip/website/assets/banner2.png',
        'https://cdn.magicmart.vip/website/assets/banner3.png'
      ],
      autoPlayInterval: null
    }
  },
  mounted() {
    this.startAutoPlay()
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  methods: {
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length
      this.resetAutoPlay()
    },
    prevSlide() {
      this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length
      this.resetAutoPlay()
    },
    goToSlide(index) {
      this.currentIndex = index
      this.resetAutoPlay()
    },
    startAutoPlay() {
      this.autoPlayInterval = setInterval(() => {
        this.nextSlide()
      }, 3000)
    },
    stopAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval)
        this.autoPlayInterval = null
      }
    },
    resetAutoPlay() {
      this.stopAutoPlay()
      this.startAutoPlay()
    }
  }
}
</script>

<style scoped>
.banner {
  width: 100%;
  height: 1000px;
  overflow: hidden;
}

.carousel-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.carousel-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease-in-out;
}

.carousel-item {
  width: 100%;
  height: 100%;
  flex-shrink: 0;
  position: relative;
}

.banner-pic {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.slogan {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 594px;
  height: 190px;
}

.arrow {
  position: absolute;
  top: 50%;
  width: 60px;
  height: 60px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.arrow img {
  width: 100%;
  height: 100%;
}

.arrow-left {
  left: 131px;
}

.arrow-right {
  right: 131px;
}

.dots {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
  z-index: 10;
}

.dot {
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: rgba(0,0,0,0.5);
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid #FFFFFF;
}

.dot:hover {
  background: #A34EFF;
}

.dot.active {
  background: #A34EFF;
}
</style>
